import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    postcreateblogRequest: ['payload', 'after', 'callback'],
    postcreateblogSuccess: ['response'],
    postcreateblogFailure: null,

    addforumtopicRequest: ['payload', 'after', 'callback'],
    addforumtopicSuccess: ['response'],
    addforumtopicFailure: null,

    getforumindividualtopicRequest: ['payload', 'route'],
    getforumindividualtopicSuccess: ['response'],
    getforumindividualtopicFailure: null,

    addtopiccommentRequest: ['payload', 'callback'],
    addtopiccommentSuccess: ['response'],
    addtopiccommentFailure: null,

    editforumtopicRequest: ['payload'],
    editforumtopicSuccess: ['response'],
    editforumtopicFailure: null,

    deleteforumtopicRequest: ['payload', 'callback'],
    deleteforumtopicSuccess: null,
    deleteforumtopicFailure: null,

    getblogsummaryRequest: ['payload'],
    getblogsummarySuccess: ['response'],
    getblogsummaryFailure: null,

    getblogdetailsRequest: ['userId', 'payload', 'callback', 'route', 'after'],
    getblogdetailsSuccess: ['response'],
    getblogdetailsFailure: null,

    getcommunityblogRequest: ['payload'],
    getcommunityblogSuccess: ['response'],
    getcommunityblogFailure: null,

    getcommunityuserRequest: ['payload', 'callback', 'route', 'after', 'loading'],
    getcommunityuserSuccess: ['response'],
    getcommunityuserFailure: null,

    postcommunityuserRequest: ['payload'],
    postcommunityuserSuccess: ['response'],
    postcommunityuserFailure: null,

    postsaveusercontentRequest: ['payload'],
    postsaveusercontentSuccess: ['response'],
    postsaveusercontentFailure: null,

    getcommunityconnectionsRequest: ['payload'],
    getcommunityconnectionsSuccess: ['response'],
    getcommunityconnectionsFailure: null,

    postcommunityconnectRequest: ['payload', 'route', 'after', 'callback'],
    postcommunityconnectSuccess: ['response'],
    postcommunityconnectFailure: null,

    getuserpermissionsRequest: ['payload'],
    getuserpermissionsSuccess: ['response'],
    getuserpermissionsFailure: null,

    postpasswordchangeRequest: ['payload'],
    postpasswordchangeSuccess: null,
    postpasswordchangeFailure: null,

    postunfollowRequest: ['payload'],
    postunfollowSuccess: ['response'],
    postunfollowFailure: null,

    postconnectionupdateRequest: ['payload'],
    postconnectionupdateSuccess: ['response'],
    postconnectionupdateFailure: null,

    postregisteruserRequest: ['payload', 'route', 'after'],
    postregisteruserSuccess: null,
    postregisteruserFailure: null,

    gettopicsRequest: ['payload', 'loading'],
    gettopicsSuccess: ['categoryId', 'response'],
    gettopicsFailure: null,

    getalldepartmentforumtopicsRequest: null,
    getalldepartmentforumtopicsSuccess: ['response'],
    getalldepartmentforumtopicsFailure: null,

    getcomblogpostsRequest: ['payload', 'target'],
    getcomblogpostsSuccess: ['response', 'target'],
    getcomblogpostsFailure: null,

    geteditfeatureditemsRequest: ['target', 'payload', 'after', 'loading'],
    geteditfeatureditemsSuccess: ['response'],
    geteditfeatureditemsFailure: null,

    getfeatureditemsRequest: ['target', 'payload'],
    getfeatureditemsSuccess: ['response'],
    getfeatureditemsFailure: null,

    getfeaturedcategoriesRequest: ['payload'],
    getfeaturedcategoriesSuccess: ['response'],
    getfeaturedcategoriesFailure: null,

    postsavefeatureditemRequest: ['target', 'payload', 'after'],
    postsavefeatureditemSuccess: ['response'],
    postsavefeatureditemFailure: null,

    postarchivefeatureditemRequest: ['payload'],
    postarchivefeatureditemSuccess: ['response'],
    postarchivefeatureditemFailure: null,

    getcategorysponsoredproductsRequest: ['categoryId', 'loading'],
    getcategorysponsoredproductsSuccess: ['id', 'response'],
    getcategorysponsoredproductsFailure: null,

    postsavecommentRequest: ['payload', 'callback'],
    postsavecommentSuccess: ['response'],
    postsavecommentFailure: null,

    postcontentflagRequest: ['payload', 'route', 'after', 'callback'],
    postcontentflagSuccess: ['response'],
    postcontentflagFailure: null,

    addcontenteventRequest: ['payload', 'loading'],
    addcontenteventSuccess: ['response'],
    addcontenteventFailure: null,

    featuredpostsRequest: ['url'],
    featuredpostsSuccess: ['response'],
    featuredpostsFailure: null,

    getemployersearchRequest: ['payload'],
    getemployersearchSuccess: ['response'],
    getemployersearchFailure: null,

    resetRequest: null,

    // Clear all caches
    clearRequest: null,
});

export const CommunityTypes = Types;
export default Creators;
